// source: acompanha/account/v1/account.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_auth_v1_auth_pb = require('../../../acompanha/auth/v1/auth_pb.js');
goog.object.extend(proto, acompanha_auth_v1_auth_pb);
var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.account.v1.GetAccountRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetAccountResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetIntegrationsRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetIntegrationsResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetMySubscriptionRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetMySubscriptionResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetPlanUsageRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetPlanUsageResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.ListSubscriptionPlansRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.ListSubscriptionPlansResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.MigratePlanRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.MigratePlanResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.MySubscriptionData', null, global);
goog.exportSymbol('proto.acompanha.account.v1.PendingSubscriptionCharge', null, global);
goog.exportSymbol('proto.acompanha.account.v1.PlanQuotaUsage', null, global);
goog.exportSymbol('proto.acompanha.account.v1.StartSubscriptionCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.StartSubscriptionCheckoutResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.SubscriptionPaymentRecord', null, global);
goog.exportSymbol('proto.acompanha.account.v1.SubscriptionPlanOption', null, global);
goog.exportSymbol('proto.acompanha.account.v1.SubscriptionPlanSnapshot', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdateAvatarRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdateAvatarResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdatePasswordRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdatePasswordResponse', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdateProfileRequest', null, global);
goog.exportSymbol('proto.acompanha.account.v1.UpdateProfileResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetAccountRequest.displayName = 'proto.acompanha.account.v1.GetAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetAccountResponse.displayName = 'proto.acompanha.account.v1.GetAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdateProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdateProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdateProfileRequest.displayName = 'proto.acompanha.account.v1.UpdateProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdateProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdateProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdateProfileResponse.displayName = 'proto.acompanha.account.v1.UpdateProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdatePasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdatePasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdatePasswordRequest.displayName = 'proto.acompanha.account.v1.UpdatePasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdatePasswordResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdatePasswordResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdatePasswordResponse.displayName = 'proto.acompanha.account.v1.UpdatePasswordResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdateAvatarRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdateAvatarRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdateAvatarRequest.displayName = 'proto.acompanha.account.v1.UpdateAvatarRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.UpdateAvatarResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.UpdateAvatarResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.UpdateAvatarResponse.displayName = 'proto.acompanha.account.v1.UpdateAvatarResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.SubscriptionPlanOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.account.v1.SubscriptionPlanOption.repeatedFields_, null);
};
goog.inherits(proto.acompanha.account.v1.SubscriptionPlanOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.SubscriptionPlanOption.displayName = 'proto.acompanha.account.v1.SubscriptionPlanOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.PlanQuotaUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.PlanQuotaUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.PlanQuotaUsage.displayName = 'proto.acompanha.account.v1.PlanQuotaUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.SubscriptionPlanSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.SubscriptionPlanSnapshot.displayName = 'proto.acompanha.account.v1.SubscriptionPlanSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.PendingSubscriptionCharge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.PendingSubscriptionCharge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.PendingSubscriptionCharge.displayName = 'proto.acompanha.account.v1.PendingSubscriptionCharge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.SubscriptionPaymentRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.SubscriptionPaymentRecord.displayName = 'proto.acompanha.account.v1.SubscriptionPaymentRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.MySubscriptionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.account.v1.MySubscriptionData.repeatedFields_, null);
};
goog.inherits(proto.acompanha.account.v1.MySubscriptionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.MySubscriptionData.displayName = 'proto.acompanha.account.v1.MySubscriptionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetPlanUsageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetPlanUsageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetPlanUsageRequest.displayName = 'proto.acompanha.account.v1.GetPlanUsageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetPlanUsageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.account.v1.GetPlanUsageResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.account.v1.GetPlanUsageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetPlanUsageResponse.displayName = 'proto.acompanha.account.v1.GetPlanUsageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetMySubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetMySubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetMySubscriptionRequest.displayName = 'proto.acompanha.account.v1.GetMySubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetMySubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetMySubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetMySubscriptionResponse.displayName = 'proto.acompanha.account.v1.GetMySubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.ListSubscriptionPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.ListSubscriptionPlansRequest.displayName = 'proto.acompanha.account.v1.ListSubscriptionPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.account.v1.ListSubscriptionPlansResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.account.v1.ListSubscriptionPlansResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.ListSubscriptionPlansResponse.displayName = 'proto.acompanha.account.v1.ListSubscriptionPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.MigratePlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.MigratePlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.MigratePlanRequest.displayName = 'proto.acompanha.account.v1.MigratePlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.MigratePlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.MigratePlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.MigratePlanResponse.displayName = 'proto.acompanha.account.v1.MigratePlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.displayName = 'proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.displayName = 'proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.StartSubscriptionCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.displayName = 'proto.acompanha.account.v1.StartSubscriptionCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.StartSubscriptionCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.displayName = 'proto.acompanha.account.v1.StartSubscriptionCheckoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.displayName = 'proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.displayName = 'proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetIntegrationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetIntegrationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetIntegrationsRequest.displayName = 'proto.acompanha.account.v1.GetIntegrationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.account.v1.GetIntegrationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.account.v1.GetIntegrationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.account.v1.GetIntegrationsResponse.displayName = 'proto.acompanha.account.v1.GetIntegrationsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetAccountRequest}
 */
proto.acompanha.account.v1.GetAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetAccountRequest;
  return proto.acompanha.account.v1.GetAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetAccountRequest}
 */
proto.acompanha.account.v1.GetAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && acompanha_auth_v1_auth_pb.User.toObject(includeInstance, f),
plan: (f = msg.getPlan()) && acompanha_common_v1_common_pb.PlanInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetAccountResponse}
 */
proto.acompanha.account.v1.GetAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetAccountResponse;
  return proto.acompanha.account.v1.GetAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetAccountResponse}
 */
proto.acompanha.account.v1.GetAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_auth_v1_auth_pb.User;
      reader.readMessage(value,acompanha_auth_v1_auth_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PlanInfo;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanInfo.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_auth_v1_auth_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PlanInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.auth.v1.User user = 1;
 * @return {?proto.acompanha.auth.v1.User}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.getUser = function() {
  return /** @type{?proto.acompanha.auth.v1.User} */ (
    jspb.Message.getWrapperField(this, acompanha_auth_v1_auth_pb.User, 1));
};


/**
 * @param {?proto.acompanha.auth.v1.User|undefined} value
 * @return {!proto.acompanha.account.v1.GetAccountResponse} returns this
*/
proto.acompanha.account.v1.GetAccountResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.GetAccountResponse} returns this
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional acompanha.common.v1.PlanInfo plan = 2;
 * @return {?proto.acompanha.common.v1.PlanInfo}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.getPlan = function() {
  return /** @type{?proto.acompanha.common.v1.PlanInfo} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PlanInfo, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PlanInfo|undefined} value
 * @return {!proto.acompanha.account.v1.GetAccountResponse} returns this
*/
proto.acompanha.account.v1.GetAccountResponse.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.GetAccountResponse} returns this
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.GetAccountResponse.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdateProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
whatsapp: jspb.Message.getFieldWithDefault(msg, 3, ""),
site: jspb.Message.getFieldWithDefault(msg, 4, ""),
instagram: jspb.Message.getFieldWithDefault(msg, 5, ""),
tiktok: jspb.Message.getFieldWithDefault(msg, 6, ""),
storeName: jspb.Message.getFieldWithDefault(msg, 7, ""),
address: jspb.Message.getFieldWithDefault(msg, 8, ""),
addressNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
addressComplement: jspb.Message.getFieldWithDefault(msg, 10, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 11, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 12, ""),
city: jspb.Message.getFieldWithDefault(msg, 13, ""),
state: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest}
 */
proto.acompanha.account.v1.UpdateProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdateProfileRequest;
  return proto.acompanha.account.v1.UpdateProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest}
 */
proto.acompanha.account.v1.UpdateProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWhatsapp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSite(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstagram(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiktok(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressComplement(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdateProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWhatsapp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSite();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInstagram();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTiktok();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStoreName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddressComplement();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string whatsapp = 3;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getWhatsapp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setWhatsapp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string site = 4;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getSite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setSite = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string instagram = 5;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getInstagram = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setInstagram = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string tiktok = 6;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getTiktok = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setTiktok = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string store_name = 7;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getStoreName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setStoreName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string address = 8;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address_number = 9;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getAddressNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setAddressNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string address_complement = 10;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getAddressComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setAddressComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string neighborhood = 11;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string zip_code = 12;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string city = 13;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string state = 14;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateProfileRequest} returns this
 */
proto.acompanha.account.v1.UpdateProfileRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdateProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdateProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdateProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && acompanha_auth_v1_auth_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdateProfileResponse}
 */
proto.acompanha.account.v1.UpdateProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdateProfileResponse;
  return proto.acompanha.account.v1.UpdateProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdateProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdateProfileResponse}
 */
proto.acompanha.account.v1.UpdateProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_auth_v1_auth_pb.User;
      reader.readMessage(value,acompanha_auth_v1_auth_pb.User.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdateProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdateProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdateProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_auth_v1_auth_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.auth.v1.User data = 1;
 * @return {?proto.acompanha.auth.v1.User}
 */
proto.acompanha.account.v1.UpdateProfileResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.auth.v1.User} */ (
    jspb.Message.getWrapperField(this, acompanha_auth_v1_auth_pb.User, 1));
};


/**
 * @param {?proto.acompanha.auth.v1.User|undefined} value
 * @return {!proto.acompanha.account.v1.UpdateProfileResponse} returns this
*/
proto.acompanha.account.v1.UpdateProfileResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.UpdateProfileResponse} returns this
 */
proto.acompanha.account.v1.UpdateProfileResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.UpdateProfileResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdatePasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdatePasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPassword: jspb.Message.getFieldWithDefault(msg, 1, ""),
newPassword: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdatePasswordRequest}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdatePasswordRequest;
  return proto.acompanha.account.v1.UpdatePasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdatePasswordRequest}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdatePasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdatePasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string current_password = 1;
 * @return {string}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.getCurrentPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdatePasswordRequest} returns this
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.setCurrentPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_password = 2;
 * @return {string}
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdatePasswordRequest} returns this
 */
proto.acompanha.account.v1.UpdatePasswordRequest.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdatePasswordResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdatePasswordResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdatePasswordResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdatePasswordResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
updated: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdatePasswordResponse}
 */
proto.acompanha.account.v1.UpdatePasswordResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdatePasswordResponse;
  return proto.acompanha.account.v1.UpdatePasswordResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdatePasswordResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdatePasswordResponse}
 */
proto.acompanha.account.v1.UpdatePasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdatePasswordResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdatePasswordResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdatePasswordResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdatePasswordResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdated();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool updated = 1;
 * @return {boolean}
 */
proto.acompanha.account.v1.UpdatePasswordResponse.prototype.getUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.UpdatePasswordResponse} returns this
 */
proto.acompanha.account.v1.UpdatePasswordResponse.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdateAvatarRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdateAvatarRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateAvatarRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
image: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdateAvatarRequest}
 */
proto.acompanha.account.v1.UpdateAvatarRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdateAvatarRequest;
  return proto.acompanha.account.v1.UpdateAvatarRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdateAvatarRequest}
 */
proto.acompanha.account.v1.UpdateAvatarRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdateAvatarRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdateAvatarRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateAvatarRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string image = 1;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateAvatarRequest.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateAvatarRequest} returns this
 */
proto.acompanha.account.v1.UpdateAvatarRequest.prototype.setImage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.UpdateAvatarResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.UpdateAvatarResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.UpdateAvatarResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateAvatarResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
imageUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.UpdateAvatarResponse}
 */
proto.acompanha.account.v1.UpdateAvatarResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.UpdateAvatarResponse;
  return proto.acompanha.account.v1.UpdateAvatarResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.UpdateAvatarResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.UpdateAvatarResponse}
 */
proto.acompanha.account.v1.UpdateAvatarResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.UpdateAvatarResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.UpdateAvatarResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.UpdateAvatarResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.UpdateAvatarResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string image_url = 1;
 * @return {string}
 */
proto.acompanha.account.v1.UpdateAvatarResponse.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.UpdateAvatarResponse} returns this
 */
proto.acompanha.account.v1.UpdateAvatarResponse.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.account.v1.SubscriptionPlanOption.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.SubscriptionPlanOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.SubscriptionPlanOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPlanOption.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
monthlyBilledValue: jspb.Message.getFieldWithDefault(msg, 4, 0),
featuresList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
limitsList: jspb.Message.toObjectList(msg.getLimitsList(),
    acompanha_common_v1_common_pb.PlanLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.SubscriptionPlanOption;
  return proto.acompanha.account.v1.SubscriptionPlanOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.SubscriptionPlanOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyBilledValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatures(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.PlanLimit;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanLimit.deserializeBinaryFromReader);
      msg.addLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.SubscriptionPlanOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.SubscriptionPlanOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPlanOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMonthlyBilledValue();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      acompanha_common_v1_common_pb.PlanLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 monthly_billed_value = 4;
 * @return {number}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getMonthlyBilledValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setMonthlyBilledValue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string features = 5;
 * @return {!Array<string>}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setFeaturesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.addFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.clearFeaturesList = function() {
  return this.setFeaturesList([]);
};


/**
 * repeated acompanha.common.v1.PlanLimit limits = 6;
 * @return {!Array<!proto.acompanha.common.v1.PlanLimit>}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.getLimitsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PlanLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PlanLimit, 6));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PlanLimit>} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
*/
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.setLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.acompanha.common.v1.PlanLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PlanLimit}
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.addLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.acompanha.common.v1.PlanLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanOption.prototype.clearLimitsList = function() {
  return this.setLimitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.PlanQuotaUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.PlanQuotaUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.PlanQuotaUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
period: jspb.Message.getFieldWithDefault(msg, 3, ""),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
used: jspb.Message.getFieldWithDefault(msg, 5, 0),
unlimited: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
blocked: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage}
 */
proto.acompanha.account.v1.PlanQuotaUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.PlanQuotaUsage;
  return proto.acompanha.account.v1.PlanQuotaUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.PlanQuotaUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage}
 */
proto.acompanha.account.v1.PlanQuotaUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriod(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsed(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimited(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.PlanQuotaUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.PlanQuotaUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.PlanQuotaUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriod();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUsed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getUnlimited();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getBlocked();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string period = 3;
 * @return {string}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getPeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 used = 5;
 * @return {number}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool unlimited = 6;
 * @return {boolean}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getUnlimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setUnlimited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool blocked = 7;
 * @return {boolean}
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.getBlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage} returns this
 */
proto.acompanha.account.v1.PlanQuotaUsage.prototype.setBlocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
subscriptionPrice: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.SubscriptionPlanSnapshot;
  return proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubscriptionPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionPrice();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 subscription_price = 3;
 * @return {number}
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.getSubscriptionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.account.v1.SubscriptionPlanSnapshot} returns this
 */
proto.acompanha.account.v1.SubscriptionPlanSnapshot.prototype.setSubscriptionPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.PendingSubscriptionCharge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.PendingSubscriptionCharge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.toObject = function(includeInstance, msg) {
  var f, obj = {
boletoAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
pixAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
boletoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
pixQrUrl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.PendingSubscriptionCharge;
  return proto.acompanha.account.v1.PendingSubscriptionCharge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.PendingSubscriptionCharge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoletoAvailable(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPixAvailable(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoletoUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPixQrUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.PendingSubscriptionCharge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.PendingSubscriptionCharge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoletoAvailable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPixAvailable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBoletoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPixQrUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool boleto_available = 1;
 * @return {boolean}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.getBoletoAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge} returns this
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.setBoletoAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool pix_available = 2;
 * @return {boolean}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.getPixAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge} returns this
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.setPixAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string boleto_url = 3;
 * @return {string}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.getBoletoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge} returns this
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.setBoletoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pix_qr_url = 4;
 * @return {string}
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.getPixQrUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.PendingSubscriptionCharge} returns this
 */
proto.acompanha.account.v1.PendingSubscriptionCharge.prototype.setPixQrUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.SubscriptionPaymentRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.SubscriptionPaymentRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionPlanUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
subscriptionPlanName: jspb.Message.getFieldWithDefault(msg, 3, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 6, ""),
chargeGeneratedAt: (f = msg.getChargeGeneratedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
paidAt: (f = msg.getPaidAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
reviewedAt: (f = msg.getReviewedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
receiptUrl: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.SubscriptionPaymentRecord;
  return proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.SubscriptionPaymentRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionPlanUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionPlanName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setChargeGeneratedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPaidAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReviewedAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.SubscriptionPaymentRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.SubscriptionPaymentRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionPlanUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionPlanName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getChargeGeneratedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPaidAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReviewedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_plan_uuid = 2;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getSubscriptionPlanUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setSubscriptionPlanUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_plan_name = 3;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getSubscriptionPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setSubscriptionPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 amount_cents = 4;
 * @return {number}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rejection_reason = 6;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp charge_generated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getChargeGeneratedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
*/
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setChargeGeneratedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.clearChargeGeneratedAt = function() {
  return this.setChargeGeneratedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.hasChargeGeneratedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp paid_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getPaidAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
*/
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setPaidAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.clearPaidAt = function() {
  return this.setPaidAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.hasPaidAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
*/
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
*/
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp reviewed_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getReviewedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
*/
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setReviewedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.clearReviewedAt = function() {
  return this.setReviewedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.hasReviewedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string receipt_url = 12;
 * @return {string}
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord} returns this
 */
proto.acompanha.account.v1.SubscriptionPaymentRecord.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.account.v1.MySubscriptionData.repeatedFields_ = [7,9,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.MySubscriptionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.MySubscriptionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MySubscriptionData.toObject = function(includeInstance, msg) {
  var f, obj = {
plan: (f = msg.getPlan()) && acompanha_common_v1_common_pb.PlanInfo.toObject(includeInstance, f),
pendingPlan: (f = msg.getPendingPlan()) && proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject(includeInstance, f),
pendingDowngradePlan: (f = msg.getPendingDowngradePlan()) && proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject(includeInstance, f),
planMigrationPending: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
planDowngradePending: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
planRenewalDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
plansList: jspb.Message.toObjectList(msg.getPlansList(),
    proto.acompanha.account.v1.SubscriptionPlanOption.toObject, includeInstance),
latestPayment: (f = msg.getLatestPayment()) && proto.acompanha.account.v1.SubscriptionPaymentRecord.toObject(includeInstance, f),
paymentsList: jspb.Message.toObjectList(msg.getPaymentsList(),
    proto.acompanha.account.v1.SubscriptionPaymentRecord.toObject, includeInstance),
pendingCharge: (f = msg.getPendingCharge()) && proto.acompanha.account.v1.PendingSubscriptionCharge.toObject(includeInstance, f),
usageList: jspb.Message.toObjectList(msg.getUsageList(),
    proto.acompanha.account.v1.PlanQuotaUsage.toObject, includeInstance),
mpSubscriptionStatus: jspb.Message.getFieldWithDefault(msg, 12, ""),
checkoutPending: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
trialActive: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
graceUntil: jspb.Message.getFieldWithDefault(msg, 15, ""),
mpPreapprovalId: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.MySubscriptionData}
 */
proto.acompanha.account.v1.MySubscriptionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.MySubscriptionData;
  return proto.acompanha.account.v1.MySubscriptionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.MySubscriptionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.MySubscriptionData}
 */
proto.acompanha.account.v1.MySubscriptionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PlanInfo;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanInfo.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    case 2:
      var value = new proto.acompanha.account.v1.SubscriptionPlanSnapshot;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader);
      msg.setPendingPlan(value);
      break;
    case 3:
      var value = new proto.acompanha.account.v1.SubscriptionPlanSnapshot;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader);
      msg.setPendingDowngradePlan(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanMigrationPending(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanDowngradePending(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanRenewalDate(value);
      break;
    case 7:
      var value = new proto.acompanha.account.v1.SubscriptionPlanOption;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanOption.deserializeBinaryFromReader);
      msg.addPlans(value);
      break;
    case 8:
      var value = new proto.acompanha.account.v1.SubscriptionPaymentRecord;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinaryFromReader);
      msg.setLatestPayment(value);
      break;
    case 9:
      var value = new proto.acompanha.account.v1.SubscriptionPaymentRecord;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinaryFromReader);
      msg.addPayments(value);
      break;
    case 10:
      var value = new proto.acompanha.account.v1.PendingSubscriptionCharge;
      reader.readMessage(value,proto.acompanha.account.v1.PendingSubscriptionCharge.deserializeBinaryFromReader);
      msg.setPendingCharge(value);
      break;
    case 11:
      var value = new proto.acompanha.account.v1.PlanQuotaUsage;
      reader.readMessage(value,proto.acompanha.account.v1.PlanQuotaUsage.deserializeBinaryFromReader);
      msg.addUsage(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpSubscriptionStatus(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCheckoutPending(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrialActive(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraceUntil(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpPreapprovalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.MySubscriptionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.MySubscriptionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MySubscriptionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PlanInfo.serializeBinaryToWriter
    );
  }
  f = message.getPendingPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getPendingDowngradePlan();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getPlanMigrationPending();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPlanDowngradePending();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPlanRenewalDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.acompanha.account.v1.SubscriptionPlanOption.serializeBinaryToWriter
    );
  }
  f = message.getLatestPayment();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.acompanha.account.v1.SubscriptionPaymentRecord.serializeBinaryToWriter
    );
  }
  f = message.getPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.acompanha.account.v1.SubscriptionPaymentRecord.serializeBinaryToWriter
    );
  }
  f = message.getPendingCharge();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.acompanha.account.v1.PendingSubscriptionCharge.serializeBinaryToWriter
    );
  }
  f = message.getUsageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.acompanha.account.v1.PlanQuotaUsage.serializeBinaryToWriter
    );
  }
  f = message.getMpSubscriptionStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCheckoutPending();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getTrialActive();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getGraceUntil();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMpPreapprovalId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PlanInfo plan = 1;
 * @return {?proto.acompanha.common.v1.PlanInfo}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPlan = function() {
  return /** @type{?proto.acompanha.common.v1.PlanInfo} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PlanInfo, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PlanInfo|undefined} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubscriptionPlanSnapshot pending_plan = 2;
 * @return {?proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPendingPlan = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPlanSnapshot} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanSnapshot, 2));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPlanSnapshot|undefined} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPendingPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPendingPlan = function() {
  return this.setPendingPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.hasPendingPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SubscriptionPlanSnapshot pending_downgrade_plan = 3;
 * @return {?proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPendingDowngradePlan = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPlanSnapshot} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanSnapshot, 3));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPlanSnapshot|undefined} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPendingDowngradePlan = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPendingDowngradePlan = function() {
  return this.setPendingDowngradePlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.hasPendingDowngradePlan = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool plan_migration_pending = 4;
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPlanMigrationPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setPlanMigrationPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool plan_downgrade_pending = 5;
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPlanDowngradePending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setPlanDowngradePending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string plan_renewal_date = 6;
 * @return {string}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPlanRenewalDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setPlanRenewalDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated SubscriptionPlanOption plans = 7;
 * @return {!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPlansList = function() {
  return /** @type{!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanOption, 7));
};


/**
 * @param {!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.account.v1.SubscriptionPlanOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.addPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.account.v1.SubscriptionPlanOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPlansList = function() {
  return this.setPlansList([]);
};


/**
 * optional SubscriptionPaymentRecord latest_payment = 8;
 * @return {?proto.acompanha.account.v1.SubscriptionPaymentRecord}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getLatestPayment = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPaymentRecord} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPaymentRecord, 8));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPaymentRecord|undefined} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setLatestPayment = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearLatestPayment = function() {
  return this.setLatestPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.hasLatestPayment = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated SubscriptionPaymentRecord payments = 9;
 * @return {!Array<!proto.acompanha.account.v1.SubscriptionPaymentRecord>}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPaymentsList = function() {
  return /** @type{!Array<!proto.acompanha.account.v1.SubscriptionPaymentRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.account.v1.SubscriptionPaymentRecord, 9));
};


/**
 * @param {!Array<!proto.acompanha.account.v1.SubscriptionPaymentRecord>} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.acompanha.account.v1.SubscriptionPaymentRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.SubscriptionPaymentRecord}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.addPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.acompanha.account.v1.SubscriptionPaymentRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPaymentsList = function() {
  return this.setPaymentsList([]);
};


/**
 * optional PendingSubscriptionCharge pending_charge = 10;
 * @return {?proto.acompanha.account.v1.PendingSubscriptionCharge}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getPendingCharge = function() {
  return /** @type{?proto.acompanha.account.v1.PendingSubscriptionCharge} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.PendingSubscriptionCharge, 10));
};


/**
 * @param {?proto.acompanha.account.v1.PendingSubscriptionCharge|undefined} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setPendingCharge = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearPendingCharge = function() {
  return this.setPendingCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.hasPendingCharge = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated PlanQuotaUsage usage = 11;
 * @return {!Array<!proto.acompanha.account.v1.PlanQuotaUsage>}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getUsageList = function() {
  return /** @type{!Array<!proto.acompanha.account.v1.PlanQuotaUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.account.v1.PlanQuotaUsage, 11));
};


/**
 * @param {!Array<!proto.acompanha.account.v1.PlanQuotaUsage>} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
*/
proto.acompanha.account.v1.MySubscriptionData.prototype.setUsageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.acompanha.account.v1.PlanQuotaUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.addUsage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.acompanha.account.v1.PlanQuotaUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.clearUsageList = function() {
  return this.setUsageList([]);
};


/**
 * optional string mp_subscription_status = 12;
 * @return {string}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getMpSubscriptionStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setMpSubscriptionStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool checkout_pending = 13;
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getCheckoutPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setCheckoutPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool trial_active = 14;
 * @return {boolean}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getTrialActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setTrialActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string grace_until = 15;
 * @return {string}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getGraceUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setGraceUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string mp_preapproval_id = 16;
 * @return {string}
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.getMpPreapprovalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MySubscriptionData} returns this
 */
proto.acompanha.account.v1.MySubscriptionData.prototype.setMpPreapprovalId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetPlanUsageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetPlanUsageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetPlanUsageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetPlanUsageRequest}
 */
proto.acompanha.account.v1.GetPlanUsageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetPlanUsageRequest;
  return proto.acompanha.account.v1.GetPlanUsageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetPlanUsageRequest}
 */
proto.acompanha.account.v1.GetPlanUsageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetPlanUsageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetPlanUsageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetPlanUsageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.account.v1.GetPlanUsageResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetPlanUsageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetPlanUsageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetPlanUsageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usageList: jspb.Message.toObjectList(msg.getUsageList(),
    proto.acompanha.account.v1.PlanQuotaUsage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetPlanUsageResponse}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetPlanUsageResponse;
  return proto.acompanha.account.v1.GetPlanUsageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetPlanUsageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetPlanUsageResponse}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.account.v1.PlanQuotaUsage;
      reader.readMessage(value,proto.acompanha.account.v1.PlanQuotaUsage.deserializeBinaryFromReader);
      msg.addUsage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetPlanUsageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetPlanUsageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetPlanUsageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.account.v1.PlanQuotaUsage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PlanQuotaUsage usage = 1;
 * @return {!Array<!proto.acompanha.account.v1.PlanQuotaUsage>}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.getUsageList = function() {
  return /** @type{!Array<!proto.acompanha.account.v1.PlanQuotaUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.account.v1.PlanQuotaUsage, 1));
};


/**
 * @param {!Array<!proto.acompanha.account.v1.PlanQuotaUsage>} value
 * @return {!proto.acompanha.account.v1.GetPlanUsageResponse} returns this
*/
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.setUsageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.account.v1.PlanQuotaUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.PlanQuotaUsage}
 */
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.addUsage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.account.v1.PlanQuotaUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.GetPlanUsageResponse} returns this
 */
proto.acompanha.account.v1.GetPlanUsageResponse.prototype.clearUsageList = function() {
  return this.setUsageList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetMySubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetMySubscriptionRequest}
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetMySubscriptionRequest;
  return proto.acompanha.account.v1.GetMySubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetMySubscriptionRequest}
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetMySubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetMySubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetMySubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetMySubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.account.v1.MySubscriptionData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetMySubscriptionResponse}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetMySubscriptionResponse;
  return proto.acompanha.account.v1.GetMySubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetMySubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetMySubscriptionResponse}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.account.v1.MySubscriptionData;
      reader.readMessage(value,proto.acompanha.account.v1.MySubscriptionData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetMySubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetMySubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.account.v1.MySubscriptionData.serializeBinaryToWriter
    );
  }
};


/**
 * optional MySubscriptionData data = 1;
 * @return {?proto.acompanha.account.v1.MySubscriptionData}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.account.v1.MySubscriptionData} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.MySubscriptionData, 1));
};


/**
 * @param {?proto.acompanha.account.v1.MySubscriptionData|undefined} value
 * @return {!proto.acompanha.account.v1.GetMySubscriptionResponse} returns this
*/
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.GetMySubscriptionResponse} returns this
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.GetMySubscriptionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.ListSubscriptionPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansRequest}
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.ListSubscriptionPlansRequest;
  return proto.acompanha.account.v1.ListSubscriptionPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansRequest}
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.ListSubscriptionPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.ListSubscriptionPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.ListSubscriptionPlansResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
plansList: jspb.Message.toObjectList(msg.getPlansList(),
    proto.acompanha.account.v1.SubscriptionPlanOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansResponse}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.ListSubscriptionPlansResponse;
  return proto.acompanha.account.v1.ListSubscriptionPlansResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansResponse}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.account.v1.SubscriptionPlanOption;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanOption.deserializeBinaryFromReader);
      msg.addPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.ListSubscriptionPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.account.v1.SubscriptionPlanOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionPlanOption plans = 1;
 * @return {!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.getPlansList = function() {
  return /** @type{!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanOption, 1));
};


/**
 * @param {!Array<!proto.acompanha.account.v1.SubscriptionPlanOption>} value
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansResponse} returns this
*/
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.setPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.account.v1.SubscriptionPlanOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.account.v1.SubscriptionPlanOption}
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.addPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.account.v1.SubscriptionPlanOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.account.v1.ListSubscriptionPlansResponse} returns this
 */
proto.acompanha.account.v1.ListSubscriptionPlansResponse.prototype.clearPlansList = function() {
  return this.setPlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.MigratePlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.MigratePlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.MigratePlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MigratePlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
planUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.MigratePlanRequest}
 */
proto.acompanha.account.v1.MigratePlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.MigratePlanRequest;
  return proto.acompanha.account.v1.MigratePlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.MigratePlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.MigratePlanRequest}
 */
proto.acompanha.account.v1.MigratePlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.MigratePlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.MigratePlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.MigratePlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MigratePlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string plan_uuid = 1;
 * @return {string}
 */
proto.acompanha.account.v1.MigratePlanRequest.prototype.getPlanUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MigratePlanRequest} returns this
 */
proto.acompanha.account.v1.MigratePlanRequest.prototype.setPlanUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.MigratePlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.MigratePlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MigratePlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
changeType: jspb.Message.getFieldWithDefault(msg, 1, ""),
user: (f = msg.getUser()) && acompanha_auth_v1_auth_pb.User.toObject(includeInstance, f),
plan: (f = msg.getPlan()) && acompanha_common_v1_common_pb.PlanInfo.toObject(includeInstance, f),
pendingPlan: (f = msg.getPendingPlan()) && proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject(includeInstance, f),
pendingDowngradePlan: (f = msg.getPendingDowngradePlan()) && proto.acompanha.account.v1.SubscriptionPlanSnapshot.toObject(includeInstance, f),
planMigrationPending: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
planDowngradePending: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
planRenewalDate: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse}
 */
proto.acompanha.account.v1.MigratePlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.MigratePlanResponse;
  return proto.acompanha.account.v1.MigratePlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.MigratePlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse}
 */
proto.acompanha.account.v1.MigratePlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangeType(value);
      break;
    case 2:
      var value = new acompanha_auth_v1_auth_pb.User;
      reader.readMessage(value,acompanha_auth_v1_auth_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.PlanInfo;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanInfo.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    case 4:
      var value = new proto.acompanha.account.v1.SubscriptionPlanSnapshot;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader);
      msg.setPendingPlan(value);
      break;
    case 5:
      var value = new proto.acompanha.account.v1.SubscriptionPlanSnapshot;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPlanSnapshot.deserializeBinaryFromReader);
      msg.setPendingDowngradePlan(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanMigrationPending(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanDowngradePending(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanRenewalDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.MigratePlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.MigratePlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.MigratePlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_auth_v1_auth_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.PlanInfo.serializeBinaryToWriter
    );
  }
  f = message.getPendingPlan();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getPendingDowngradePlan();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.acompanha.account.v1.SubscriptionPlanSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getPlanMigrationPending();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPlanDowngradePending();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPlanRenewalDate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string change_type = 1;
 * @return {string}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getChangeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.setChangeType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.auth.v1.User user = 2;
 * @return {?proto.acompanha.auth.v1.User}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getUser = function() {
  return /** @type{?proto.acompanha.auth.v1.User} */ (
    jspb.Message.getWrapperField(this, acompanha_auth_v1_auth_pb.User, 2));
};


/**
 * @param {?proto.acompanha.auth.v1.User|undefined} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
*/
proto.acompanha.account.v1.MigratePlanResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional acompanha.common.v1.PlanInfo plan = 3;
 * @return {?proto.acompanha.common.v1.PlanInfo}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPlan = function() {
  return /** @type{?proto.acompanha.common.v1.PlanInfo} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PlanInfo, 3));
};


/**
 * @param {?proto.acompanha.common.v1.PlanInfo|undefined} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
*/
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SubscriptionPlanSnapshot pending_plan = 4;
 * @return {?proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPendingPlan = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPlanSnapshot} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanSnapshot, 4));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPlanSnapshot|undefined} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
*/
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPendingPlan = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.clearPendingPlan = function() {
  return this.setPendingPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.hasPendingPlan = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SubscriptionPlanSnapshot pending_downgrade_plan = 5;
 * @return {?proto.acompanha.account.v1.SubscriptionPlanSnapshot}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPendingDowngradePlan = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPlanSnapshot} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPlanSnapshot, 5));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPlanSnapshot|undefined} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
*/
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPendingDowngradePlan = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.clearPendingDowngradePlan = function() {
  return this.setPendingDowngradePlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.hasPendingDowngradePlan = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool plan_migration_pending = 6;
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPlanMigrationPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPlanMigrationPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool plan_downgrade_pending = 7;
 * @return {boolean}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPlanDowngradePending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPlanDowngradePending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string plan_renewal_date = 8;
 * @return {string}
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.getPlanRenewalDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.MigratePlanResponse} returns this
 */
proto.acompanha.account.v1.MigratePlanResponse.prototype.setPlanRenewalDate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
receipt: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest;
  return proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceipt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceipt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string receipt = 1;
 * @return {string}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.prototype.getReceipt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} returns this
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest.prototype.setReceipt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.account.v1.SubscriptionPaymentRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse;
  return proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.account.v1.SubscriptionPaymentRecord;
      reader.readMessage(value,proto.acompanha.account.v1.SubscriptionPaymentRecord.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.account.v1.SubscriptionPaymentRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPaymentRecord data = 1;
 * @return {?proto.acompanha.account.v1.SubscriptionPaymentRecord}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.account.v1.SubscriptionPaymentRecord} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.account.v1.SubscriptionPaymentRecord, 1));
};


/**
 * @param {?proto.acompanha.account.v1.SubscriptionPaymentRecord|undefined} value
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse} returns this
*/
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse} returns this
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.StartSubscriptionCheckoutRequest;
  return proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
checkoutUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
mpPreapprovalId: jspb.Message.getFieldWithDefault(msg, 2, ""),
exempt: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.StartSubscriptionCheckoutResponse;
  return proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpPreapprovalId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExempt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckoutUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMpPreapprovalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExempt();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string checkout_url = 1;
 * @return {string}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.getCheckoutUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} returns this
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.setCheckoutUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mp_preapproval_id = 2;
 * @return {string}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.getMpPreapprovalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} returns this
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.setMpPreapprovalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool exempt = 3;
 * @return {boolean}
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.getExempt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse} returns this
 */
proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.prototype.setExempt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
preapprovalId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest;
  return proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreapprovalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreapprovalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string preapproval_id = 1;
 * @return {string}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.prototype.getPreapprovalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest.prototype.setPreapprovalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
mpSubscriptionStatus: jspb.Message.getFieldWithDefault(msg, 1, ""),
checkoutPending: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
trialActive: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
graceUntil: jspb.Message.getFieldWithDefault(msg, 4, ""),
plan: (f = msg.getPlan()) && acompanha_common_v1_common_pb.PlanInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse;
  return proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpSubscriptionStatus(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCheckoutPending(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrialActive(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraceUntil(value);
      break;
    case 5:
      var value = new acompanha_common_v1_common_pb.PlanInfo;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanInfo.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMpSubscriptionStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCheckoutPending();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTrialActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getGraceUntil();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      acompanha_common_v1_common_pb.PlanInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string mp_subscription_status = 1;
 * @return {string}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.getMpSubscriptionStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.setMpSubscriptionStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool checkout_pending = 2;
 * @return {boolean}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.getCheckoutPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.setCheckoutPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool trial_active = 3;
 * @return {boolean}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.getTrialActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.setTrialActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string grace_until = 4;
 * @return {string}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.getGraceUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.setGraceUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional acompanha.common.v1.PlanInfo plan = 5;
 * @return {?proto.acompanha.common.v1.PlanInfo}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.getPlan = function() {
  return /** @type{?proto.acompanha.common.v1.PlanInfo} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PlanInfo, 5));
};


/**
 * @param {?proto.acompanha.common.v1.PlanInfo|undefined} value
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
*/
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse} returns this
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetIntegrationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetIntegrationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetIntegrationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetIntegrationsRequest}
 */
proto.acompanha.account.v1.GetIntegrationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetIntegrationsRequest;
  return proto.acompanha.account.v1.GetIntegrationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetIntegrationsRequest}
 */
proto.acompanha.account.v1.GetIntegrationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetIntegrationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetIntegrationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetIntegrationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.account.v1.GetIntegrationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.account.v1.GetIntegrationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetIntegrationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasProAccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
planName: jspb.Message.getFieldWithDefault(msg, 2, ""),
integrationKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.account.v1.GetIntegrationsResponse}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.account.v1.GetIntegrationsResponse;
  return proto.acompanha.account.v1.GetIntegrationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.account.v1.GetIntegrationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.account.v1.GetIntegrationsResponse}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasProAccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntegrationKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.account.v1.GetIntegrationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.account.v1.GetIntegrationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.account.v1.GetIntegrationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasProAccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPlanName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIntegrationKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool has_pro_access = 1;
 * @return {boolean}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.getHasProAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.account.v1.GetIntegrationsResponse} returns this
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.setHasProAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string plan_name = 2;
 * @return {string}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.getPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.GetIntegrationsResponse} returns this
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.setPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string integration_key = 3;
 * @return {string}
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.getIntegrationKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.account.v1.GetIntegrationsResponse} returns this
 */
proto.acompanha.account.v1.GetIntegrationsResponse.prototype.setIntegrationKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.acompanha.account.v1);
